import React from 'react';
import { Header, Message } from 'semantic-ui-react';

/**
 * Placeholder for the Variation Header component
 * This will be replaced with the new variationWorksheet implementation
 * 
 * @param {Object} props - Component props
 * @param {string} props.title - The title to display
 * @param {string} props.error - Error message to display
 * @returns {JSX.Element} VariationHeader component
 */
const VariationHeader = ({ title, error }) => {
  return (
    <>
      <Header as="h2" style={{ marginBottom: '1rem' }}>
        {title || 'Variation Management'}
      </Header>

      {error && (
        <Message negative>
          <Message.Header>Error</Message.Header>
          <p>{error}</p>
        </Message>
      )}
    </>
  );
};

export default VariationHeader;
